import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Editor } from 'slate-react';
import { PlusIcon, MoreIcon, DeleteIcon, InsertTopIcon, InsertBottomIcon } from '../../../components/Icons';
import TableIconWrapper from './TableIconWrapper';
import TooltipOnHover from '../../../components/TooltipOnHover';
import PopoverOnClick from '../../../components/PopoverOnClick';
import Menu from '../../../components/Menu';
import GutterBlockTypes, { TABLE_ACTION_EVENT } from '../../../types/GutterBlockTypes';

var TableRowControls =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TableRowControls, _PureComponent);

  function TableRowControls(props) {
    var _this;

    _classCallCheck(this, TableRowControls);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableRowControls).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSelectionChange", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          selectedRowIndex = _ref.selectedRowIndex;

      if (selectedRowIndex === _this.props.rowIndex && !_this.state.showActions) {
        _this.setState({
          showActions: true
        });
      } else if (selectedRowIndex !== _this.props.rowIndex && _this.state.showActions) {
        _this.setState({
          showActions: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAddRowAbove", function () {
      _this.props.editor.addTableRow(_this.props.tableId, _this.props.rowIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAddRowBelow", function () {
      _this.props.editor.addTableRow(_this.props.tableId, _this.props.rowIndex + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickRemoveRow", function () {
      _this.props.editor.removeTableRow(_this.props.tableId, _this.props.rowIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSelectRow", function () {
      _this.props.editor.selectTableRow(_this.props.tableId, _this.props.rowIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (position) {
      return function () {
        _this.props.editor.setHoveredRow({
          index: _this.props.rowIndex + position,
          withDragLine: true
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.props.editor.setHoveredRow(null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (_ref2) {
      var closePopover = _ref2.closePopover;
      return React.createElement(Menu, {
        onRowClick: closePopover,
        className: "slite-design-system",
        style: {
          width: 158
        },
        items: _this.menuItems
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideGutterBlock", function (hide) {
      var _this$props = _this.props,
          editor = _this$props.editor,
          tableId = _this$props.tableId;
      var priority = hide ? {
        priority: 0
      } : {};
      editor.command('updateGutterBlock', _objectSpread({
        gutterBlockType: GutterBlockTypes.ALL_BLOCKS,
        nodeId: editor.getTable(tableId).key
      }, priority, {
        origin: TABLE_ACTION_EVENT
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onEnterRowControl", function () {
      var _this$props2 = _this.props,
          rowIndex = _this$props2.rowIndex,
          editor = _this$props2.editor;

      if (!rowIndex) {
        _this.hideGutterBlock(true);
      }

      editor.setHoveredRowControls(rowIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onLeaveRowControl", function () {
      var _this$props3 = _this.props,
          rowIndex = _this$props3.rowIndex,
          editor = _this$props3.editor;

      if (!rowIndex) {
        _this.hideGutterBlock(false);
      }

      editor.setHoveredRowControls(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onIsOpenChange", function (_ref3) {
      var isOpen = _ref3.isOpen;
      isOpen && _this.onClickSelectRow();

      _this.setState({
        menuOpened: isOpen
      });
    });

    _this.state = {
      showActions: false
    };
    _this.menuItems = [{
      key: 'insert-top',
      title: 'Insert top',
      icon: InsertTopIcon,
      action: _this.onClickAddRowAbove
    }, {
      key: 'insert-bottom',
      title: 'Insert bottom',
      icon: InsertBottomIcon,
      action: _this.onClickAddRowBelow
    }, {
      key: 'delete-column',
      title: 'Delete',
      icon: DeleteIcon,
      action: _this.onClickRemoveRow
    }];
    return _this;
  }

  _createClass(TableRowControls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onSelectionChange(this.props.store.getItem(this.props.tableId));
      this.props.store.subscribeToItem(this.props.tableId, this.onSelectionChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.store.unsubscribeFromItem(this.props.tableId, this.onSelectionChange);
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props4 = this.props,
          editor = _this$props4.editor,
          tableId = _this$props4.tableId,
          isLastRow = _this$props4.isLastRow;
      var menuOpened = this.state.menuOpened;
      var canAddRow = editor.canAddTableRow(tableId);
      var visibility = menuOpened ? {
        opacity: 0,
        visibility: 'hidden'
      } : {};
      return React.createElement(Fragment, null, canAddRow && React.createElement(TableIconWrapper, {
        style: _objectSpread({
          bottom: "calc(100% - 10px)",
          right: 'calc(100% + 4px)'
        }, visibility),
        className: "top",
        onClick: this.onClickAddRowAbove,
        tooltipContent: "Add row",
        onMouseEnter: this.onMouseEnter(-1),
        onMouseLeave: this.onMouseLeave
      }, React.createElement(PlusIcon, {
        size: 12
      })), isLastRow && canAddRow && React.createElement(TableIconWrapper, {
        style: _objectSpread({
          top: "calc(100% - 10px)",
          right: 'calc(100% + 4px)'
        }, visibility),
        className: "bottom",
        onClick: this.onClickAddRowBelow,
        tooltipContent: "Add row",
        onMouseEnter: this.onMouseEnter(0),
        onMouseLeave: this.onMouseLeave
      }, React.createElement(PlusIcon, {
        size: 12
      })), React.createElement("div", {
        className: "slite-editor-table-cell-drag-line horizontal"
      }, React.createElement("div", {
        className: "drag-line-background"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var showActions = this.state.showActions;
      var _this$props5 = this.props,
          isMobile = _this$props5.isMobile,
          isFocused = _this$props5.isFocused;
      return React.createElement("th", {
        className: classNames('slite-editor-table-row-control', {
          'is-selected': showActions
        }),
        contentEditable: false,
        onMouseEnter: this.onEnterRowControl,
        onMouseLeave: this.onLeaveRowControl
      }, React.createElement("div", {
        className: "slite-editor-table-row-control-container"
      }, React.createElement("div", {
        className: classNames('slite-editor-table-controls position-relative transition', {
          'selection-in': isFocused
        })
      }, !isMobile && this.renderActions(), React.createElement("div", {
        className: classNames('slite-editor-table-control pointer background-shade-50 background-shade-40-on-hover transition', {
          'is-selected': showActions
        }),
        onClick: this.onClickSelectRow
      }, !isMobile && React.createElement("div", {
        className: "slite-editor-table-action-placeholder background-shade-45 top-placeholder"
      }), React.createElement(PopoverOnClick, {
        onIsOpenChange: this.onIsOpenChange,
        position: "left",
        content: this.renderMenu
      }, React.createElement("div", {
        className: "flexbox"
      }, React.createElement(TooltipOnHover, {
        id: "slite-editor-table-row-control",
        placement: "left",
        tooltipContent: "Options",
        disabled: isMobile
      }, React.createElement(MoreIcon, {
        className: "slite-editor-table-more-icon transition",
        size: 12
      })))), !isMobile && React.createElement("div", {
        className: "slite-editor-table-action-placeholder background-shade-45 bottom-placeholder"
      })))));
    }
  }]);

  return TableRowControls;
}(PureComponent);

_defineProperty(TableRowControls, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  store: PropTypes.shape({
    getItem: PropTypes.func,
    subscribeToItem: PropTypes.func,
    unsubscribeFromItem: PropTypes.func
  }),
  tableId: PropTypes.string,
  rowIndex: PropTypes.number,
  isLastRow: PropTypes.bool,
  isMobile: PropTypes.bool,
  isFocused: PropTypes.bool
});

export { TableRowControls as default };